import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home/Home";
import Navbar from "./components/Navbar/Navbar";
import './App.css'
import Footer from "./components/Footer/Footer";
import About from "./components/About/About";
import Solutions from "./components/Solutions/Solutions";
import Contact from "./components/Contact/Contact";
import ServiceDetail from "./components/Solutions/ServiceDetail";
import ScrollToTop from "./components/ScrollToTop";
import Resources from "./components/Resources/Resources";
import BlogDetails from "./components/Resources/BlogDetails";
import CaseStudyDetails from "./components/Resources/CaseStudyDetails";
import Careers from "./components/Careers/Careers";
import PrivacyPolicy from "./components/Contact/PrivacyPolicy";
import WhatsAppFloat from "./components/WhatsAppFloat";




function App() {
  return (
    <Router>
<ScrollToTop/>
     <Navbar/>
      <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/about-us" element={<About/>} />
      <Route path="/solutions" element={<Solutions/>}/>
      <Route path="/contact-us" element={<Contact/>}/>
      <Route path="/solutions/:slug" element={<ServiceDetail/>}/>
      <Route path="/resources" element={<Resources/>}/>
      <Route path="/blogs/:title" element={<BlogDetails/>}/>
      <Route path="/case-study/:title" element={<CaseStudyDetails/>}/>
      <Route path="/careers" element={<Careers/>}/>
      <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
      </Routes>
    <Footer/>
    <WhatsAppFloat/>
    </Router>
  );
}

export default App;
